import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { ArrowUpRight } from "lucide-react";
import { isLocalhost } from "replo-runtime/shared/env";

function getBraintrustLink(opencodeSessionId: string): string {
  const filterText = `metadata.session_id = "${opencodeSessionId}"`;
  return `https://www.braintrust.dev/app/Replo/p/Replo%20Opencode/logs?search=${encodeURIComponent(
    JSON.stringify({
      filter: [{ text: filterText, label: filterText, originType: "btql" }],
    }),
  )}`;
}

function getRaindropLink({
  opencodeSessionId,
  messageCreatedAt,
}: {
  opencodeSessionId: string;
  messageCreatedAt: Date;
}): string {
  const DAY_MS = 24 * 60 * 60 * 1000;
  const from = new Date(messageCreatedAt.getTime() - DAY_MS);
  const to = new Date(messageCreatedAt.getTime() + DAY_MS);
  return `https://app.raindrop.ai/events?tableFilters=${encodeURIComponent(
    JSON.stringify([
      {
        field: "timestamp",
        value: { from: from.toISOString(), to: to.toISOString() },
      },
      { field: "convoId", value: [opencodeSessionId] },
    ]),
  )}&tableSorting=${encodeURIComponent(
    JSON.stringify([{ field: "timestamp", direction: "desc" }]),
  )}`;
}

function getReploAdminLink(sessionUuid: string): string {
  return `https://admin.replo.app/dashboard/chats?sessionUuid=${sessionUuid}`;
}

export function ChatDebugPanel({
  opencodeSessionId,
  sessionUuid,
  messageCreatedAt,
}: {
  opencodeSessionId: string | null;
  sessionUuid: string | null;
  messageCreatedAt: Date;
}) {
  if (!opencodeSessionId) {
    return null;
  }

  const braintrustLink = getBraintrustLink(opencodeSessionId);
  const raindropLink = getRaindropLink({ opencodeSessionId, messageCreatedAt });

  return (
    <div className="flex flex-row gap-2">
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          window.open(braintrustLink, "_blank");
        }}
        endEnhancer={<ArrowUpRight />}
      >
        Braintrust Logs
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          window.open(raindropLink, "_blank");
        }}
        endEnhancer={<ArrowUpRight />}
      >
        Raindrop Logs
      </Button>
      {sessionUuid && !isLocalhost() && (
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            window.open(getReploAdminLink(sessionUuid), "_blank");
          }}
          endEnhancer={<ArrowUpRight />}
        >
          Replo Admin
        </Button>
      )}
    </div>
  );
}
